export default __webpack_public_path__ + "a1a2bbf1f5edc7d33e2a88c736482668.woff";